import React from "react";

const IconButton = ({ icon, text, onClick, style }) => {
  return (
    <button onClick={onClick} style={{ ...buttonStyle, ...style }}>
      {icon && <div style={iconStyle}>{icon}</div>}
      {text && <div>{text}</div>}
    </button>
  );
};

const buttonStyle = {
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  border: "none",
  borderRadius: "5px",
  backgroundColor: "#4CAF50",
  color: "#fff",
  cursor: "pointer",
  fontSize: "13px",
  whiteSpace: "nowrap",
  height: '2rem'
};

const iconStyle = {
  marginRight: "10px",
  display: "flex",
  alignItems: "center",
};

export default IconButton;
